import React, { useState, useEffect, useCallback } from "react";
import { makeRequestAuth } from "../../../_config/api";
import { ToastContainer } from "react-toastify";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import {
    Users, Building2, ShieldCheck, Stethoscope,
    MapPin, Landmark, UserCircle, ChevronRight,
    AlertCircle, CheckCircle, Clock, ChevronDown,
    Save, HelpCircle, Edit2
} from "lucide-react";

const LocalForm = ({ data, preview, handleChange, handleStateGovChange, loading, errors, setPreview, onSave }) => {
    const [expandedSections, setExpandedSections] = useState({});
    const [localErrors, setLocalErrors] = useState({});
    const [isEditing, setIsEditing] = useState(false);


    const toggleSection = (section) => {
        setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
    };

    // const validateForm = () => {
    //     const newErrors = {};
    //     if (!data.sarpanchOrMLA?.trim()) newErrors.sarpanchOrMLA = "Sarpanch/MLA name is required";
    //     if (!data.partyName?.trim()) newErrors.partyName = "Political party name is required";
    //     if (!data.partyOfficeAddress?.trim()) newErrors.partyOfficeAddress = "Party office address is required";
    //     if (!data.policeASI?.trim()) newErrors.policeASI = "Police ASI name is required";
    //     if (!data.policeHawaldar?.trim()) newErrors.policeHawaldar = "Police name is required";
    //     if (!data.nearbyHospital?.trim()) newErrors.nearbyHospital = "Nearby hospital name is required";
    //     if (!data.stateGovernment?.party?.trim()) newErrors.stateParty = "State gov party is required";
    //     if (!data.stateGovernment?.cmName?.trim()) newErrors.cmName = "Chief Minister name is required";

    //     setLocalErrors(newErrors);
    //     return Object.keys(newErrors).length === 0;
    // };

    const handleSubmit = (e) => {
        e.preventDefault();
        // if (validateForm() && onSave) {
        onSave();
        // }
    };

    // If in preview mode
    if (preview && preview.sarpanchOrMLA && !isEditing) {
        return (
            <div className="w-full max-w-5xl mx-auto px-3 sm:px-4 md:px-6 py-4 sm:py-6 md:py-10">
                <ToastContainer position="top-right" autoClose={3000} />

                {/* Header */}
                <div className="bg-gradient-to-r from-blue-900 to-blue-800 rounded-t-xl sm:rounded-t-2xl md:rounded-t-3xl p-5 sm:p-6 md:p-8 text-white shadow-xl">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <div className="flex items-center gap-3 sm:gap-4">
                            <div className="p-2 sm:p-3 bg-white/10 rounded-xl backdrop-blur-sm">
                                <Building2 size={24} className="text-blue-300" />
                            </div>
                            <div>
                                <h1 className="text-xl sm:text-2xl md:text-3xl font-bold">Local Authority Details</h1>
                                <p className="text-blue-100/80 text-[10px] sm:text-xs mt-0.5">Verified Local Information</p>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="bg-white rounded-b-xl sm:rounded-b-2xl md:rounded-b-3xl shadow-xl border-x border-b border-gray-100 p-5 sm:p-6 md:p-8">
                    {preview?.status === "approve" && (
                        <div className="mb-6 bg-gradient-to-r from-green-50 to-emerald-50 p-4 rounded-xl border border-green-100 flex items-center gap-3">
                            <CheckCircle size={20} className="text-green-600 shrink-0" />
                            <p className="text-sm font-medium text-green-800">Local authority information verified and approved</p>
                        </div>
                    )}

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
                        <PreviewItem icon={<Landmark className="text-indigo-500" />} label="Sarpanch / MLA" value={preview.sarpanchOrMLA} />
                        <PreviewItem icon={<Users className="text-blue-500" />} label="Political Party" value={preview.partyName} />
                        <PreviewItem icon={<ShieldCheck className="text-slate-500" />} label="Police ASI" value={preview.policeASI} />
                        <PreviewItem icon={<ShieldCheck className="text-slate-400" />} label="Police " value={preview.policeHawaldar} />
                        <PreviewItem icon={<Stethoscope className="text-rose-500" />} label="Nearby Hospital" value={preview.nearbyHospital} />
                        <PreviewItem icon={<UserCircle className="text-amber-500" />} label="Chief Minister" value={preview?.stateGovernment?.cmName} />
                        <div className="sm:col-span-2 lg:col-span-3 bg-indigo-50/50 p-4 sm:p-5 rounded-xl border border-indigo-100">
                            <PreviewItem icon={<MapPin className="text-indigo-600" />} label="Party Office Address" value={preview.partyOfficeAddress} />
                        </div>
                    </div>

                    {(preview?.status === "reject" || !preview?.status) && (
                        <div className="flex justify-center pt-6 mt-4 border-t border-gray-100">
                            <button
                                onClick={() => setIsEditing(true)}
                                className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 sm:px-8 py-3 rounded-xl font-semibold text-sm transition-all shadow-md"
                            >
                                <Edit2 size={16} /> Edit Local Authority Info
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className="w-full max-w-5xl mx-auto px-3 sm:px-4 md:px-6 py-4 sm:py-6 md:py-10">
            <ToastContainer position="top-right" autoClose={3000} />

            {loading && (
                <div className="fixed inset-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center">
                    <div className="bg-white p-6 rounded-2xl shadow-xl flex flex-col items-center gap-3">
                        <div className="w-10 h-10 border-4 border-gray-200 border-t-blue-600 rounded-full animate-spin"></div>
                        <p className="text-sm font-medium text-blue-600">Updating records...</p>
                    </div>
                </div>
            )}

            {/* Header */}
            <div className="bg-gradient-to-r from-blue-900 to-blue-800 rounded-t-xl sm:rounded-t-2xl md:rounded-t-3xl p-5 sm:p-6 md:p-8 text-white shadow-xl">
                <div className="flex items-center gap-3 sm:gap-4">
                    <div className="p-2 sm:p-3 bg-white/10 rounded-xl backdrop-blur-sm">
                        <Building2 size={24} className="text-blue-300" />
                    </div>
                    <div>
                        <h1 className="text-xl sm:text-2xl md:text-3xl font-bold">Local Authority Details</h1>
                        <p className="text-blue-100/80 text-[10px] sm:text-xs mt-0.5">Please provide accurate local governance information</p>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-b-xl sm:rounded-b-2xl md:rounded-b-3xl shadow-xl border-x border-b border-gray-100 p-5 sm:p-6 md:p-8">

                {/* Error Display */}
                {(Object.keys(localErrors).length > 0 || errors?.length > 0) && (
                    <div className="mb-6 bg-rose-50 border border-rose-200 p-4 rounded-xl animate-in fade-in slide-in-from-top-4">
                        <div className="flex items-center gap-2 text-rose-700 font-medium mb-2">
                            <AlertCircle size={18} /> Please correct the following:
                        </div>
                        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1">
                            {Object.values(localErrors).map((err, i) => (
                                <li key={i} className="text-rose-600 text-[11px] py-0.5">• {err}</li>
                            ))}
                            {errors?.map((err, i) => (
                                <li key={`err-${i}`} className="text-rose-600 text-[11px] py-0.5">• {err}</li>
                            ))}
                        </ul>
                    </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6 sm:space-y-8">
                    {/* Main Section */}
                    <div className="space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-5">
                            <Input
                                label="Sarpanch / MLA Name"
                                value={data.sarpanchOrMLA || ""}
                                onChange={(v) => handleChange("sarpanchOrMLA", v || "")}  // Convert to string
                                error={localErrors.sarpanchOrMLA}
                                required
                                placeholder="e.g."
                            />
                            <Input
                                label="Political Party Name"
                                value={data.partyName || ""}
                                onChange={(v) => handleChange("partyName", v || "")}
                                error={localErrors.partyName}
                                required
                                placeholder="e.g., "
                            />
                        </div>

                        <Textarea
                            label="Party Office Address"
                            value={data.partyOfficeAddress || ""}
                            onChange={(v) => handleChange("partyOfficeAddress", v || "")}
                            error={localErrors.partyOfficeAddress}
                            required
                            placeholder="Full address of the party office"
                        />

                        {/* Police Details Section - Collapsible on mobile */}
                        <div className={`bg-gray-50 rounded-xl overflow-hidden border border-gray-200 transition-all
                            ${expandedSections.policeDetails ? 'shadow-md' : ''}`}>
                            <div
                                className="flex justify-between items-center p-4 cursor-pointer md:cursor-default bg-gray-100/50"
                                onClick={() => toggleSection('policeDetails')}
                            >
                                <div className="flex items-center gap-2">
                                    <ShieldCheck size={18} className="text-blue-600" />
                                    <h3 className="font-bold text-gray-800 text-sm">Police Station Details</h3>
                                </div>
                                <button className="md:hidden text-gray-400">
                                    <ChevronDown size={18} className={`transition-transform ${expandedSections.policeDetails ? 'rotate-180' : ''}`} />
                                </button>
                            </div>
                            <div className={`
                                transition-all duration-300 overflow-hidden
                                ${expandedSections.policeDetails !== false ? 'max-h-[500px] opacity-100' : 'max-h-0 md:max-h-[500px] md:opacity-100'}
                            `}>
                                <div className="p-4 pt-0 space-y-4">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <Input
                                            label="Police ASI Name"
                                            value={data.policeASI || ""}
                                            onChange={(v) => handleChange("policeASI", v || "")}
                                            error={localErrors.policeASI}
                                            required
                                            placeholder="e.g., ASI Ram Singh"
                                        />
                                        <Input
                                            label="Police Name"
                                            value={data.policeHawaldar || ""}
                                            onChange={(v) => handleChange("policeHawaldar", v || "")}
                                            error={localErrors.policeHawaldar}
                                            required
                                            placeholder="e.g., Hawaldar Suresh"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <Input
                            label="Nearby Hospital"
                            value={data.nearbyHospital}
                            onChange={(v) => handleChange("nearbyHospital", v)}
                            error={localErrors.nearbyHospital}
                            required
                            placeholder="e.g., District Hospital, City Hospital"
                        />

                        {/* State Government Section - Collapsible on mobile */}
                        <div className={`bg-indigo-50/30 rounded-xl overflow-hidden border border-indigo-100 transition-all
                            ${expandedSections.stateGov ? 'shadow-md' : ''}`}>
                            <div
                                className="flex justify-between items-center p-4 cursor-pointer md:cursor-default bg-indigo-100/30"
                                onClick={() => toggleSection('stateGov')}
                            >
                                <div className="flex items-center gap-2">
                                    <Building2 size={18} className="text-indigo-600" />
                                    <h3 className="font-bold text-gray-800 text-sm">State Government Details</h3>
                                </div>
                                <button className="md:hidden text-gray-400">
                                    <ChevronDown size={18} className={`transition-transform ${expandedSections.stateGov ? 'rotate-180' : ''}`} />
                                </button>
                            </div>
                            <div className={`
                                transition-all duration-300 overflow-hidden
                                ${expandedSections.stateGov !== false ? 'max-h-[500px] opacity-100' : 'max-h-0 md:max-h-[500px] md:opacity-100'}
                            `}>
                                <div className="p-4 pt-0 space-y-4">
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <Input
                                            label="State Gov Party"
                                            value={data.stateGovernment?.party}
                                            onChange={(v) => handleStateGovChange("party", v)}
                                            error={localErrors.stateParty}
                                            required
                                            placeholder="e.g., Indian National Congress"
                                        />
                                        <Input
                                            label="Chief Minister Name"
                                            value={data.stateGovernment?.cmName}
                                            onChange={(v) => handleStateGovChange("cmName", v)}
                                            error={localErrors.cmName}
                                            required
                                            placeholder="e.g., Shri Narendra Modi"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </form>
            </div>
        </div>
    );
};

/* REUSABLE SUB-COMPONENTS */
const Input = ({ label, value, onChange, error, required, placeholder }) => (
    <div className="space-y-1.5">
        <label className="text-[10px] sm:text-[11px] font-bold text-gray-600 uppercase tracking-wider ml-1">
            {label} {required && <span className="text-rose-500">*</span>}
        </label>
        <input
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className={`w-full bg-gray-50 border rounded-xl px-4 py-2.5 sm:py-3 focus:border-blue-500 focus:bg-white outline-none transition-all text-sm
                ${error ? "border-rose-300 bg-rose-50/30" : "border-gray-200"}`}
        />
        {error && <p className="text-rose-500 text-[10px] mt-1 flex items-center gap-1"><AlertCircle size={12} /> {error}</p>}
    </div>
);

const Textarea = ({ label, value, onChange, error, required, placeholder }) => (
    <div className="space-y-1.5">
        <label className="text-[10px] sm:text-[11px] font-bold text-gray-600 uppercase tracking-wider ml-1">
            {label} {required && <span className="text-rose-500">*</span>}
        </label>
        <textarea
            rows={3}
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className={`w-full bg-gray-50 border rounded-xl px-4 py-2.5 sm:py-3 focus:border-blue-500 focus:bg-white outline-none transition-all text-sm resize-none
                ${error ? "border-rose-300 bg-rose-50/30" : "border-gray-200"}`}
        />
        {error && <p className="text-rose-500 text-[10px] mt-1 flex items-center gap-1"><AlertCircle size={12} /> {error}</p>}
    </div>
);

const PreviewItem = ({ icon, label, value }) => (
    <div className="flex items-start gap-3 sm:gap-4">
        <div className="mt-0.5 p-1.5 sm:p-2 bg-gray-50 rounded-lg sm:rounded-xl shrink-0">
            {React.cloneElement(icon, { size: 18, className: icon.props.className })}
        </div>
        <div className="flex flex-col min-w-0 flex-1">
            <span className="text-[9px] sm:text-[10px] uppercase tracking-widest font-bold text-gray-400 leading-none mb-1">
                {label}
            </span>
            <span className="text-gray-800 font-semibold text-sm sm:text-base break-words">
                {value || "—"}
            </span>
        </div>
    </div>
);

export default LocalForm;